export default __webpack_public_path__ + "static/media/Persona1.20f8469a.png";